import i18n from '@/i18n'
const state = {
    currency: {
        id: 1,
        key: 'aoa',
        name: 'kwanza',
        definition: {
            symbol: 'Kz',
            locale: 'pt-AO'
        }
    },
    
    list: []
}

const getters = {
    currentCurrency(state) {
        return state.currency
    },
  
    currencyList(state) {
      return state.list
    }
}

const mutations = {
  setCurrency(state, currency) {
        state.currency = currency
        document.querySelector('html').setAttribute('lang', currency.key)
        if (i18n) i18n.currency = currency.key
  },
  
  setList(state, locale) {
    state.list = locale
  }
}

// const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    // actions,
}
